import { createFileRoute } from '@tanstack/react-router'
import { ClinicEditorPage } from '@/features/clinics/editor'

export const Route = createFileRoute('/clinics_/$clinicId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { clinicId } = Route.useParams()
  return <ClinicEditorPage clinicId={clinicId} />
}
